// frontend/src/services/chatService.js
import api from "../config/api";

const chatService = {
  // Crear o obtener una conversación (método existente)
  getOrCreateConversation: async (postId, sellerId) => {
    try {
      const response = await api.post('/chat/conversation', {
        post_id: postId,
        seller_id: sellerId
      });
      return response.data;
    } catch (error) {
      console.error("Error creating conversation:", error);
      throw error;
    }
  },

  // 🔥 NUEVO: Crear o obtener conversación con mensaje inicial
  getOrCreateConversationWithMessage: async (postId, sellerId) => {
    try {
      const response = await api.post('/chat/conversation-with-message', {
        post_id: postId,
        seller_id: sellerId
      });
      return response.data;
    } catch (error) {
      console.error("Error creating conversation with message:", error);
      throw error;
    }
  },

  // Obtener conversaciones del usuario
  getConversations: async () => {
    try {
      const response = await api.get('/chat/conversations');
      return response.data;
    } catch (error) {
      console.error("Error fetching conversations:", error);
      throw error;
    }
  },

  // Obtener mensajes de una conversación
  getMessages: async (conversationId) => {
    try {
      const response = await api.get(`/chat/conversations/${conversationId}/messages`);
      return response.data;
    } catch (error) {
      console.error("Error fetching messages:", error);
      throw error;
    }
  },

  // Enviar mensaje
  sendMessage: async (conversationId, message) => {
    try {
      const response = await api.post('/chat/messages', {
        conversation_id: conversationId,
        message: message
      });
      return response.data;
    } catch (error) {
      console.error("Error sending message:", error);
      throw error;
    }
  },

  // Obtener cantidad de mensajes no leídos
  getUnreadCount: async () => {
    try {
      const response = await api.get('/chat/unread-count');
      return response.data;
    } catch (error) {
      console.error("Error fetching unread count:", error);
      return { count: 0 };
    }
  }
};

export default chatService;